import {
  COMPANY_MONTHLY_FETCH_SUCCESS,
} from '../actionTypes';

let initialState = {
  companyMonthly: [],
}

export default function ui(state = initialState, action) {
  switch(action.type) {
    case COMPANY_MONTHLY_FETCH_SUCCESS:
      if(action.payload) {
        return { ...state, companyMonthly: action.payload};
      } else {
        return state;
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/shared/reducers/selectOptions.js